<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Air Safety Report") }}:</h3>
        <p>{{ currentDate() }}</p>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <!--<md-card-header class="md-card-header-text md-primary" style="background-color: #0ABAB5;">
          <div class="card-text" style="display: block;">
            <h3 class="md-title" style="color: white;">{{ $t("Air Safety Report") }}</h3>
          </div>
        </md-card-header> -->
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("List of Air Safety Report") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">{{ $t("Per page") }}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, position) in pagination.perPageOptions"
                    :key="position"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  :placeholder="$t('Search')"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                :md-label="$t('Timestamp')"
                md-sort-by="datetime"
                >{{ item.datetime }}</md-table-cell
              >
              <md-table-cell :md-label="$t('Subject')" md-sort-by="subject">{{
                item.subject
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Name')" md-sort-by="name">{{
                item.email
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Report')">
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.pdf !== ''"
                >
                  <a target="blank" :href="MAP_SMS_URL + item.pdf">
                    <md-icon>archive</md-icon>
                  </a>
                </md-button>
                <md-button class="md-just-icon md-simple" v-else>
                  <md-icon>link_off</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell
                :md-label="$t('Status')"
                v-if="
                  (usertype === USER_TYPE.ADMIN ||
                    usertype === USER_TYPE.ENTERPRISE ||
                    usertype === USER_TYPE.SUPER) &&
                    item.acknowledged
                "
              >
                <md-button class="md-just-icon md-simple md-success">
                  <md-tooltip md-direction="top">OK</md-tooltip>
                  <md-icon>verified_user</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell
                :md-label="$t('Status')"
                v-else-if="
                  usertype === USER_TYPE.ADMIN ||
                    usertype === USER_TYPE.ENTERPRISE ||
                    usertype === USER_TYPE.SUPER
                "
              >
                <md-button
                  class="md-just-icon md-simple md-danger"
                  @click="ack(item)"
                >
                  <md-tooltip md-direction="top">{{
                    $t("Attention Required")
                  }}</md-tooltip>
                  <md-icon>warning</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              {{
                $t("Showing") +
                  (from + 1) +
                  " " +
                  $t("to") +
                  " " +
                  to +
                  " " +
                  $t("of") +
                  " " +
                  total +
                  " " +
                  $t("entries")
              }}
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-primary"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import { EventBus } from "@/helpers";
import { MAP_SMS_URL } from "@/helpers";
import swal from "sweetalert2";
import { USER_TYPE } from "@/const.js";
import { router } from "../../main";
import moment from "moment";

export default {
  components: {
    Pagination
  },
  computed: {
    ...mapMultiRowFields("survey", ["sms"]),
    ...mapFields("auth", ["usertype"]),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.sms;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.sms.length;
    }
  },
  data() {
    return {
      USER_TYPE: USER_TYPE,
      MAP_SMS_URL: MAP_SMS_URL,
      currentSort: "datetime",
      currentSortOrder: "desc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["subject", "name"],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    currentDate() {
      const current = new Date();
      const date = moment(current).format("MMMM DD, YYYY");
      return date;
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "asc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    ack(item) {
      swal
        .fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You cannot change it once you confirm!"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("survey/ackSMS", { id: item._id.$oid });
          }
        });
    }
  },
  beforeMount() {
    if (this.usertype === USER_TYPE.FREE) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("Free user cannot access this page."),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
    if (this.$store.state.sms === undefined) {
      this.$store.dispatch("survey/getSMS");
    }
  },
  mounted() {
    EventBus.$on("setSMS", () => {
      this.fuseSearch = new Fuse(this.sms, {
        keys: ["subject", "name"],
        threshold: 0.3
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("setSMS");
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.sms;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #ff9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}
</style>
